import { render, staticRenderFns } from "./TableRowActionsMenu.vue?vue&type=template&id=60f9ad58&scoped=true"
import script from "./TableRowActionsMenu.vue?vue&type=script&lang=js"
export * from "./TableRowActionsMenu.vue?vue&type=script&lang=js"
import style0 from "./TableRowActionsMenu.vue?vue&type=style&index=0&id=60f9ad58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f9ad58",
  null
  
)

export default component.exports